/* esm.sh - aria-hidden@1.2.6 */
export * from "/*aria-hidden@1.2.6/esnext/aria-hidden.mjs";
